import React, { FC, useEffect, useState } from "react";
import {
  DashBoardAlertSummary,
  DashBoardStatisticsSummary,
  LoadingBox,
} from "../../components";
import { getLookupByType } from "../../serviceBroker/lookupApiServiceBroker";
import {
  DashboardSummaryResponseModel,
  LookupTypeEnum,
  UserAlertResponseModel,
} from "../../models";
import {
  getUserAlert,
  getUserDashboardSummary,
} from "../../serviceBroker/userApiServiceBroker";
import { getLabelName, shouldUseCache} from "../../utils";
export const DashboardPage: FC = () => {
  //#region state
  const [loading, setLoading] = useState(false);
  const [userDashBoardData, setUserDashBoardData] =
    useState<DashboardSummaryResponseModel | null>(null);
  const [userAlertData, setUserAlertData] = useState<UserAlertResponseModel[]>(
    []
  );
  //#endregion
  //#region useEffect
  useEffect(() => {
    //checkUserMultipleBranchesEnabled();
    const fillData = async () => {
      setLoading(true);
      await fillLookupDataPromiseAll();
      await fillSummaryDataPromiseAll();
      setLoading(false);
    };
    fillData().then(() => {});
  }, []);
  //#endregion
  //#region functions
  const fillLookupDataPromiseAll = async () => {
    let  stores = await getLookupByType(LookupTypeEnum.Stores, true, false);
    stores=stores??[];
    const  hasSingleStore =  stores.length <= 1;
    // Define the lookup types to potentially load
    const lookupTypesToLoad: { type: LookupTypeEnum,isCached:boolean , addEmptySelect?: boolean }[] = [
      { type: LookupTypeEnum.Customers,isCached: true },
      { type: LookupTypeEnum.Supplier,isCached: true },
      { type: LookupTypeEnum.CategoryType,isCached: true, addEmptySelect: true },
      { type: LookupTypeEnum.PosCategoryType,isCached: true, addEmptySelect: true },
      { type: LookupTypeEnum.Items,isCached: true, addEmptySelect: true },
      { type: LookupTypeEnum.PaymentType,isCached: true, addEmptySelect: true },
      { type: LookupTypeEnum.Currency,isCached: true, addEmptySelect: true },
      { type: LookupTypeEnum.Employee,isCached: true, addEmptySelect: true },
      { type: LookupTypeEnum.CalcType,isCached: true },
      { type: LookupTypeEnum.CostCenter,isCached: true, addEmptySelect: true },
    ];
    // Check if caching is enabled
    // Filter lookup types based on whether caching is enabled

    const filteredLookups = lookupTypesToLoad.filter(({ type, isCached }) => {
      const cacheDecision = shouldUseCache(type);
      return cacheDecision.useCache
      //return !cacheDecision.isFromDefault ? cacheDecision.useCache : isCached;
    });
    // Fetch data for the filtered lookup types using Promise.all

    await Promise.all(
        filteredLookups.map(({ type, addEmptySelect }) =>
            getLookupByType(type, false, addEmptySelect).catch((error) => {
              return null; // Return null for failed lookups to avoid breaking Promise.all
            })
        )
    );


    // const [, , , , , , , ,,] = await Promise.all([
    //   getLookupByType(LookupTypeEnum.Customers, true, false),
    //   getLookupByType(LookupTypeEnum.Supplier, true, false),
    //   getLookupByType(LookupTypeEnum.CategoryType, true, true),
    //   getLookupByType<CategorySettingModel>(LookupTypeEnum.PosCategoryType,true,true),
    //   hasSingleStore ?getLookupByType(LookupTypeEnum.Items, true, true):Promise.resolve([]),
    //   getLookupByType(LookupTypeEnum.PaymentType, true, true),
    //   getLookupByType(LookupTypeEnum.Currency, true, true),
    //   getLookupByType(LookupTypeEnum.Employee, true, true),
    //   getLookupByType(LookupTypeEnum.CalcType, true, false),
    //   getLookupByType(LookupTypeEnum.CostCenter, true, true),
    // ]);
  };
  const fillSummaryDataPromiseAll = async () => {
    const [userDahBoardResult, userAlertsResult] = await Promise.all([
      getUserDashboardSummary(),
      getUserAlert(),
    ]);
    setUserDashBoardData(userDahBoardResult);
    setUserAlertData(userAlertsResult);
  };
  //#endregion
  //#region html
  return (
    <>
      {loading && <LoadingBox />}
      <div className="page-header">
        <h3 className="page-title">
          <span className="page-title-icon bg-gradient-primary text-white me-2">
            <i className="mdi mdi-home"></i>
          </span>{" "}
          {getLabelName("Dashboard")}
        </h3>
      </div>
      <DashBoardStatisticsSummary request={userDashBoardData} />
      <DashBoardAlertSummary request={userAlertData} />
    </>
  );
  //#endregion
};
